var scope_0 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4d1a44ef13c7e032fb4cd19af5912bc.js').default;export default
        Object.assign({}, scope_0 )
    